import { ReactNode } from 'react';
import { BordOneToneIcon } from 'components/NudosComponents';
import { nudosTextcolor } from 'styles/styles.constants';
import { TOOL_HISTORY_ITEM_TYPE } from 'types/toolHistory.types';

import './HistoryStepHeader.scss';

/**
 * Header expandible de un paso del historial
 * @param icon - Icono a mostrar
 * @param title - Título del paso
 * @param link - Link opcional
 * @param isExpandable - Si puede expandirse
 * @param isExpanded - Estado de expansión
 * @param onToggle - Callback al expandir/colapsar
 */
export const HistoryStepHeader = ({
  icon,
  title,
  link,
  isExpandable,
  isExpanded,
  onToggle
}: IHistoryStepHeaderProps) => {
  const variant = isExpanded ? 'arrowHeadUp' : 'arrowHeadDown';
  const headerClass = `historyStepHeader ${isExpandable ? 'expandable' : ''}`;

  const handleClick = () => {
    if (isExpandable && onToggle) {
      onToggle();
    }
  };

  return (
    <div className={headerClass} onClick={handleClick}>
      <div className="stepLeftContent">
        <div className="stepIconContainer">{icon}</div>
        {title && <p className="stepTitle">{title}</p>}
      </div>

      <div className="stepRightContent">
        {link && (
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="stepLink"
            onClick={e => e.stopPropagation()}
          >
            {link.label}
          </a>
        )}

        {isExpandable && (
          <div className="arrowIcon">
            <BordOneToneIcon variant={variant} standardSize={16} stroke={nudosTextcolor} viewBox="0 0 10 10" />
          </div>
        )}
      </div>
    </div>
  );
};

export interface IHistoryStepLink {
  label: string;
  url: string;
}

export interface IHistoryStepHeaderProps {
  type: TOOL_HISTORY_ITEM_TYPE;
  icon: ReactNode;
  isCancelled?: boolean;
  title?: string;
  date?: string | null;
  link?: IHistoryStepLink | null;
  isExpandable?: boolean;
  isExpanded?: boolean;
  onToggle?: () => void;
}

